import { mapPeriodsOptions } from '#models/periods';
import FileInput from '#components/general/FileInput';
import Input from '#components/general/Input';
import { ACCEPT_ONLY_EXCELS } from '#constants/files';
import { getSubStepValues } from '#models/general/steps';
import { getSelectField } from '#utils/select';

import { CASKS_SUBSTEPS_IDS, CASKS_INFORMATION_FIELDS } from './constants';

export const getCaskInformationPageFields = ({ values, errors, periods }) => {
  const getCaskInformationPageValues = getSubStepValues(
    CASKS_SUBSTEPS_IDS.CASK_FILLING_INFORMATION,
    values,
    errors
  );
  return [
    getSelectField({
      field: CASKS_INFORMATION_FIELDS.PERIOD_ID,
      values,
      options: mapPeriodsOptions(periods),
      customOptions: true,
      getValues: getCaskInformationPageValues
    }),
    {
      ...getCaskInformationPageValues(CASKS_INFORMATION_FIELDS.FILL_ID),
      Component: Input,
      noMargin: true
    },
    {
      ...getCaskInformationPageValues(CASKS_INFORMATION_FIELDS.CASK_FILLING_FILE),
      Component: FileInput,
      accept: ACCEPT_ONLY_EXCELS,
      noMargin: true,
      fileType: 'excel'
    }
  ];
};
